export default __webpack_public_path__ + "static/media/img5.87f2e033.jpg";